import { buildProductPathFromIdentity } from '../../routing'
import type { RecentlyViewedProduct } from '../../recentlyViewed'
import type { ShopI18nContextValue } from '../../../i18n/provider/types'

type RecentlyViewedProductsSectionProps = {
  products: RecentlyViewedProduct[]
  toLocalizedPath: (path: string) => string
  formatCurrency: ShopI18nContextValue['formatCurrency']
}

export const RecentlyViewedProductsSection = ({
  products,
  toLocalizedPath,
  formatCurrency,
}: RecentlyViewedProductsSectionProps) => {
  if (products.length === 0) return null

  return (
    <section className="border-t border-slate-200 pt-7">
      <header className="mb-4">
        <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">Navigazione recente</p>
        <h2 className="mt-1 text-xl font-black tracking-tight text-slate-950">Ultimi prodotti visti</h2>
      </header>
      <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-4">
        {products.map((item) => {
          const href = toLocalizedPath(buildProductPathFromIdentity({ publicCode: item.publicCode, slug: item.slug }))
          return (
            <a
              key={item.id}
              href={href}
              className="group overflow-hidden rounded-xl border border-slate-200 bg-white/90 transition hover:border-slate-400 hover:shadow-sm"
            >
              {item.imageUrl ? (
                <img
                  src={item.imageUrl}
                  alt={item.name}
                  loading="lazy"
                  decoding="async"
                  fetchPriority="low"
                  sizes="(min-width: 1280px) 20vw, (min-width: 640px) 46vw, 92vw"
                  className="h-28 w-full object-cover"
                />
              ) : (
                <div className="grid h-28 w-full place-items-center bg-slate-50 text-xl font-black text-slate-500">
                  {item.name.slice(0, 1).toUpperCase()}
                </div>
              )}
              <div className="space-y-1.5 p-3">
                <p className="max-h-10 overflow-hidden text-sm font-semibold text-slate-900">{item.name}</p>
                <p className="text-xs text-slate-500">{item.publicCode || item.slug}</p>
                {typeof item.price === 'number' ? (
                  <p className="text-sm font-bold text-slate-900">{formatCurrency(item.price)}</p>
                ) : null}
              </div>
            </a>
          )
        })}
      </div>
    </section>
  )
}
